import clsx from "clsx";
import React from "react";

interface SuffixFieldProps {
    suffix: string;
    className?: string;
    children: React.ReactNode;
    isError?: boolean;
}

export const SuffixField = ({ suffix, className, children, isError = false }: SuffixFieldProps) => {
    return (
        <div className="flex">
            <div className="relative flex flex-grow items-stretch">{children}</div>
            <div
                className={clsx(
                    "border-gray-light bg-gray-lighter text-gray-darker relative -ml-px inline-flex items-center rounded-r border px-2",
                    isError && "border-danger",
                    className,
                )}
            >
                {suffix}
            </div>
        </div>
    );
};
